import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icons, Typography } from '../../../stories/atoms';
import { ColumnFlexContainer } from '../../../stories/atoms/containerV2/ContainerV2';
import { Button } from '../../../stories/molecules';
import { commonTranslations } from '../../../translations';
import { StyledIcon } from './AccessStateView.styles';

type AccessStateViewProps = {
  isSuccess: boolean;
  message: string;
  onClose: () => void;
};

export const AccessStateView: FC<AccessStateViewProps> = ({ isSuccess, message, onClose }) => {
  const { t } = useTranslation();
  const titleText = isSuccess
    ? t(commonTranslations.successText.key, commonTranslations.successText.defaultValue)
    : t(commonTranslations.errorText1.key, commonTranslations.errorText1.defaultValue);

  const icon = isSuccess ? Icons.CHECK_MARK_CIRCLE : Icons.REFRESH;
  const testId = isSuccess ? 'success-view' : 'error-view';

  return (
    <ColumnFlexContainer data-testid={testId} alignItems="center">
      <StyledIcon icon={icon} isSuccess={isSuccess} />
      <Typography type="h4" textAlign="center" margin={[0, 0, 2]}>
        {titleText}
      </Typography>
      <Typography textAlign="center" gutterBottom>
        {message}
      </Typography>
      <Button
        label={t(commonTranslations.close.key, commonTranslations.close.defaultValue)}
        variant="secondary"
        fullWidth
        onClick={onClose}
      />
    </ColumnFlexContainer>
  );
};
